<template>
  <Popup :isShow="isShow" :preventTouchMove="false">
    <template v-if="isShow">
      <pre-guide v-if="showPreGuide" @start="handleStart" />

      <!-- 问卷说明 -->
      <ques-list
        v-else
        class="questionaire-wrapper"
        :surveyCode="surveyCode"
        :showProgressText="true"
        @refresh="handleRefresh"
      />
    </template>
  </Popup>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Popup from '@component/Popup/';
import PreGuide from './PreGuide.vue';
import QuesList from './QuesList.vue';

@Component({
  components: {
    Popup,
    PreGuide,
    QuesList,
  },
})
export default class QuestionnairePy extends Vue {
  @Prop({ type: Boolean }) isShow!: boolean;
  @Prop({ type: String, default: '' }) surveyCode!: string;

  showPreGuide = true;

  @Watch('isShow')
  init() {
    console.log(this.surveyCode);
    const index = localStorage.getItem(`${this.surveyCode}`);
    console.log(index);
    if (index) {
      this.showPreGuide = false;
    }
  }

  handleStart() {
    localStorage.setItem(`${this.surveyCode}`, '1');
    this.showPreGuide = false;
  }
  handleRefresh() {
    this.$emit('refresh');
  }
}
</script>

<style lang="scss" scoped>
$theme-color: #382d68;
$theme-active: #377ef9;
.questionaire-wrapper {
  display: flex;
  flex-direction: column;
  height: 92vh;
  padding: 42px 0;
}
</style>
